<template>
    <div class="ReportsData">
        <div class="titlePage">Reporte Acceso a Plataforma</div>
        <div class="listData" v-if="!noDtaForm">
            <DataList
                :InfoView="this.DLDataList"
                :HeadTable="this.HDDataList"
                v-if="renderComponent1"
            />
        </div>
    </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
import DataList from '@/components/data-tables/DataReportAccesoPlataforma.vue'

export default {
  name: 'ReportsData',
  components: {
    DataList,
  },
  data () {
    return {
      renderComponent1: false,
      DataList: [],
      HDDataList: [],
      DLDataList: [],
      noDtaForm: false,
    }
  },
  methods: {
    loadTableData: function () {
      for (const datRef in this.DLDataList[0]) {
        this.HDDataList.push({
          name: datRef,
          title: datRef,
          width: '10%',
        })
      }
      IberoHelpers.forceRerender1(this)
    },
  },
  created: function () {
    let loader = this.$loading.show()
    var datCaract = IberoHelpers.GetReports(this.$store, 2)
    datCaract.then(Response => {
      if (Response.data) {
        this.DLDataList = Response.data
        this.loadTableData()
      } else {
        this.noDtaForm = true
      }
      loader.hide()
    })
  },
}
</script>